import * as React from "react";
import TextAreaInput from "../commons/components/form/input/TextAreaInput";
import Form from "../commons/components/form/Form";
import { required } from "../commons/model/form/Validators";
import sfetch from "../commons/utils/super-fetch";
import ModalDelete from "../commons/components/modal/ModalDelete";
import EditAction from "../commons/components/action/EditAction";
import InputState from "../commons/model/form/InputState";

interface NoteProps {
  updateNote?: UpdateNote;
  deleteNote?: DeleteNote;
  content?: string;
  maxLength: number;
  noteTextAreaRows: number;
  onNoteChange?: (note: string) => void;
}

interface NoteState {
  isEditing?: boolean;
  content: string;
  deleteDialogVisible?: boolean;
}

export interface UpdateNote {
  url: string;
}

export interface DeleteNote {
  url: string;
}

export default class Note extends React.Component<NoteProps, NoteState> {
  constructor(props: NoteProps) {
    super(props);
    this.state = {
      content: this.props.content || "",
    };

    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.deleteNote = this.deleteNote.bind(this);
    this.submitNote = this.submitNote.bind(this);
  }

  render() {
    if (!this.state.content && !this.state.isEditing && this.props.updateNote) {
      return (
        <div onClick={this.handleEdit} className="treatments-note-add h-flex centered clickable">
          <i className="ic_plus" />
          <span>{i18n["Page.AssessmentResult.Note.Add"]}</span>
        </div>
      );
    } else if (this.state.content || this.state.isEditing) {
      const secondaryAction = {};
      if (this.props.updateNote && this.state.content) {
        secondaryAction["secondaryAction"] = () => (
          this.setState({ deleteDialogVisible: true }), Promise.resolve()
        );
        secondaryAction["secondaryActionLabel"] = i18n["Global.Delete"];
      }

      return (
        <div className="category panel with-shadow">
          <div className="panel-control">
            {this.props.updateNote &&
              (this.state.isEditing ? (
                <i className="ic_close" onClick={this.handleCancel} />
              ) : (
                <EditAction onClick={this.handleEdit} />
              ))}
          </div>
          <div className="title">
            {!this.state.isEditing
              ? i18n["Page.AssessmentResult.Note.Title"]
              : this.state.content
                ? i18n["Page.AssessmentResult.Note.Modify"]
                : i18n["Page.AssessmentResult.Note.Add"]}
          </div>
          {this.state.isEditing ? (
            <Form submit={this.submitNote} submitLabel={i18n["Global.Save"]} {...secondaryAction}>
              <TextAreaInput
                name="note"
                placeholder={i18n["Page.AssessmentResult.Note.Textarea.Placeholder"]}
                initialValue={this.state.content}
                maxLength={this.props.maxLength}
                validators={[required()]}
                rows={this.props.noteTextAreaRows}
              />
            </Form>
          ) : (
            <div>{this.state.content}</div>
          )}
          {this.state.deleteDialogVisible && (
            <ModalDelete
              title={i18n["Page.AssessmentResult.Note.Delete"]}
              action={this.deleteNote}
              cancel={() => this.setState({ deleteDialogVisible: false })}
            >
              {i18n["Page.AssessmentResult.Note.DeleteWarning"]}
            </ModalDelete>
          )}
        </div>
      );
    } else return null;
  }

  handleEdit() {
    this.setState({ isEditing: true });
  }

  handleCancel() {
    this.setState({ isEditing: false });
  }

  submitNote(form: { [key: string]: InputState }) {
    const note = form.note.value;
    return sfetch(this.props.updateNote.url, {
      method: "PUT",
      body: note,
      headers: {
        "Content-Type": "application/json",
      },
    }).then(() => {
      this.setState({
        content: note,
        isEditing: false,
      });
      this.props.onNoteChange(note);
    });
  }

  deleteNote() {
    return sfetch(this.props.deleteNote.url, { method: "DELETE" }).then(() => {
      this.setState({
        content: "",
        isEditing: false,
        deleteDialogVisible: false,
      });
      this.props.onNoteChange("");
    });
  }
}
